import React, { useState } from "react";
import "../../assets/styles/home.scss";
import { Card } from "react-bootstrap";
import Mascaras from "../../utils/masks";
import atendimentosService from "../../services/AtendimentosServices";
import { ToastError, ToastSuccess } from "../Toast/Toast";

export default function FormAtendimento() {
  const [nome, setNome] = useState();
  const [email, setEmail] = useState();
  const [telefone, setTelefone] = useState();
  const [descricao, setDescricao] = useState();

  function resetForm() {
    setTimeout(() => {
      setNome("");
      setEmail("");
      setTelefone("");
      setDescricao("");
    }, 2000);
  }

  async function cadastrarAtendimento(e) {
    e.preventDefault();
    let data = {
      nome: nome,
      email: email,
      telefone: telefone,
      descricao: descricao,
    };
    atendimentosService
      .salvarAtendimento(data)
      .then((response) => {
        ToastSuccess(response.data.message);
        resetForm();
      })
      .catch((error) => {
        const errors = error.response.data.data;
        Object.keys(errors).forEach((field) => {
          const erro = field.toUpperCase() + " " + errors[field];
          ToastError(erro);
        });
      });
  }
  return (
    <Card className="card-shadow rounded">
      <Card.Header className="card-header">
        <h2 className="text-center text-white">Abra um Chamado</h2>
      </Card.Header>
      <Card.Body>
        <div className="form">
          <p className="text-form">Abra um chamado para o suporte técnico</p>
          <form method="POST" action="">
            <label htmlFor="nome">Nome</label>
            <input
              type="text"
              name="nome"
              id="nome"
              required
              value={nome}
              onChange={(e) => setNome(e.target.value)}
            />
            <label htmlFor="email">E-mail</label>
            <input
              type="text"
              name="email"
              id="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <label htmlFor="telefone">Telefone</label>
            <input
              type="text"
              name="telefone"
              id="telefone"
              required
              value={telefone}
              onChange={(ev) =>
                setTelefone(Mascaras.maskPhone(ev.target.value))
              }
            />
            <label htmlFor="descricao">Descrição</label>
            <textarea
              name="descricao"
              id="descricao"
              cols="30"
              rows="10"
              required
              value={descricao}
              onChange={(e) => setDescricao(e.target.value)}
            ></textarea>
            <span className="message">
              Campo deve ter no mínimo 20 caracteres
            </span>
          </form>
          <div className="d-flex  justify-content-end align-items-center ">
            <button className="btn-send mt-4" onClick={cadastrarAtendimento}>
              Enviar
            </button>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}
